<template>
    <footer>
				<div class="copy">© 2024 Enzo Bijaoui. All rights reserved.</div>
	</footer>
</template>
<script>
export default {
  name: 'FooterSection'
}
</script>